import React, { useState } from 'react';
import { Check, Award, Video, Globe, FileCheck, Users, Play } from 'lucide-react';
import { VideoModal } from './VideoModal';
const reasons = ['User-friendly platform designed for non-techies', 'Arizona-based instruction relevant to your business', 'Expert-led education with real-world examples', 'Friendly local support team available by phone, text, email and chat', 'Competitive pricing'];
const renewalFeatures = [{
  icon: Award,
  text: 'ADRE-approved continuing education courses'
}, {
  icon: Video,
  text: 'On-Demand, Zoom, and In-Person classroom formats'
}, {
  icon: Globe,
  text: 'Courses focused on Arizona real estate information only'
}, {
  icon: Users,
  text: 'Local Arizona-based support team'
}];
export function WhyDesertSage() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return <section className="py-20 relative overflow-hidden" data-id="element-501">
      {/* Background Image */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rHkPcQf6JAvCmJf8o15AXs/why-bg2.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'top'
    }} data-id="element-502" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-503">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-504">
          {/* Left Content Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-10 border border-gray-100" data-id="element-505">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6" data-id="element-506">
              Why Arizona Agents Choose{' '}
              <span className="text-brand-purple-600" data-id="element-507">
                Desert Sage Seminars
              </span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-508">
              We understand that license renewal can be stressful. That's why we
              have built our entire platform around simplicity, compliance, and
              local expertise. We are not a big national chain—we are Arizona
              real estate experts helping our peers succeed.
            </p>

            <ul className="space-y-4" data-id="element-509">
              {reasons.map((reason, index) => <li key={index} className="flex items-start" data-id="element-510">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-511">
                    <Check className="w-4 h-4 text-green-600" data-id="element-512" />
                  </div>
                  <span className="ml-3 text-gray-700 font-medium" data-id="element-513">
                    {reason}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Side - License Renewal Info Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-10 border border-gray-100" data-id="element-514">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-515">
              Arizona Real Estate License Renewal — At a Glance
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-516">
              Arizona real estate agents must complete approved continuing
              education each two-year renewal cycle to stay compliant with the
              Arizona Department of Real Estate (ADRE). Desert Sage Seminars
              makes license renewal simple with ADRE-approved courses designed
              specifically for Arizona agents.
            </p>

            <ul className="space-y-4" data-id="element-517">
              {renewalFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return <li key={index} className="flex items-start" data-id="element-518">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-purple-100 flex items-center justify-center mt-0.5" data-id="element-519">
                      <Icon className="w-4 h-4 text-brand-purple-600" data-id="element-520" />
                    </div>
                    <span className="ml-3 text-gray-700 font-medium" data-id="element-521">
                      {feature.text}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} videoId="OhJuESLnDqk" title="Desert Sage Seminars — Welcome" data-id="element-522" />
    </section>;
}